import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enAU from "./en-AU";

const resources = {
  "en-AU": enAU,
};

i18next.use(initReactI18next).init({
  lng: "en-AU",
  resources,
  fallbackLng: "en-AU",
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});

export default i18next;
